import * as React from "react";
const SvgFiRrMeeting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meeting_svg__a)">
      <path
        fill="#062147"
        d="M14.928 9H15c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3H9C7.346 0 6 1.346 6 3v3c0 1.654 1.346 3 3 3h.202l1.834 1.617c.29.256.653.384 1.016.384.358 0 .716-.126.998-.376zm-2.877-.156L10.24 7.25A1 1 0 0 0 9.58 7H9c-.552 0-1-.449-1-1V3c0-.551.448-1 1-1h6c.552 0 1 .449 1 1v3c0 .551-.448 1-1 1h-.444a1 1 0 0 0-.654.244L12.05 8.845zM5.5 18C7.43 18 9 16.43 9 14.5S7.43 11 5.5 11 2 12.57 2 14.5 3.57 18 5.5 18m0-5c.827 0 1.5.673 1.5 1.5S6.327 16 5.5 16 4 15.327 4 14.5 4.673 13 5.5 13m9.5 1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5m3.5-1.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m-7.563 9.649a1.001 1.001 0 0 1-1.874.703c-.527-1.406-1.96-2.351-3.563-2.351s-3.036.945-3.563 2.351a1.001 1.001 0 0 1-1.873-.703C.882 20.466 3.067 19 5.5 19s4.617 1.466 5.436 3.649m12.415 1.288a1.003 1.003 0 0 1-1.289-.585c-.527-1.406-1.96-2.351-3.563-2.351s-3.036.945-3.563 2.351a1.001 1.001 0 0 1-1.873-.703C13.882 20.466 16.067 19 18.5 19s4.618 1.466 5.437 3.649a1 1 0 0 1-.585 1.288z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meeting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeeting;
